import React, { useEffect, useState } from 'react'
import { RouteProp } from '@react-navigation/native'
import { View } from 'react-native'
import { ScrollView } from 'react-native-gesture-handler'
import { useDispatch } from 'react-redux'
import tw from 'tailwind-rn'
import { StackNavigationProp } from '@react-navigation/stack'

import { LocationType } from '../../config/types'
import { RootStackParamList } from '../../navigators/AppNavigator'
import Location from '../../components/Location'
import ActionCreators from '../../store/actions'
import { HGView } from '../../components/HGUI'

type Props = {
  navigation: StackNavigationProp<RootStackParamList>
  route: RouteProp<RootStackParamList, 'GenericLocations'>
}

const GenericLocationsScreen = (props: Props) => {
  const dispatch = useDispatch()
  const { route, navigation } = props
  const [loading, setLoading] = useState<boolean>(false)
  const [locations, setLocations] = useState<null | Array<LocationType>>(null)
  const {
    params: { districtId, locationTypes, name },
  } = route

  useEffect(() => {
    if (name) {
      navigation.setOptions({ title: name })
    }

    setLoading(true)
    dispatch(
      ActionCreators.loadLocationsOfDistrict({ districtId, locationTypes })
    )
      .then((result) => {
        const mappedLocations: Array<LocationType> = result.map((i) => ({
          id: i.id,
          title: i.title,
          address: {
            ...i.address,
            address1: i.address?.address_1,
            address2: i.address?.address_2,
          },
          phoneNumbers: i.phone_numbers?.map(({ label, phone_number }) => ({
            label,
            phoneNumber: phone_number,
          })),
          faxNumbers: i.fax_numbers?.map(({ label, fax_number }) => ({
            label,
            faxNumber: fax_number,
          })),
          emailAddresses: i.email_addresses?.map(
            ({ label, email_address }) => ({
              label,
              emailAddress: email_address,
            })
          ),
        }))

        setLocations(mappedLocations)
      })
      .catch()
      .then(() => setLoading(false))
  }, [])

  return (
    <ScrollView>
      <HGView style={tw('px-3 pt-6')}>
        {locations &&
          locations.map((l) => {
            const { id } = l
            return (
              <View style={tw('mb-12')} key={id}>
                <Location data={l} />
              </View>
            )
          })}
      </HGView>
    </ScrollView>
  )
}

export default GenericLocationsScreen
